import { CYBER_CONSTANT } from 'constants';

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';

import './StateBadge.scss';

function StateBadge({ state }) {
  const stateClass = useMemo(() => `stateBadge--${state.toLowerCase()}`, [state]);

  const stateLabel = useMemo(() => CYBER_CONSTANT.STATES_LABEL[state], [state]);

  return (
    <>
      <div className={`stateBadge ${stateClass}`} />
      {state !== CYBER_CONSTANT.STATES.NOT_ANSWERED ? (
        <div className="stateLabelText">
          {stateLabel}
        </div>
      )
        : (
          <div className="notLabelText">
            <DoNotDisturbIcon
              sx={{
                fontSize: 16,
              }}
            />
            <div className="readjustText">
              {CYBER_CONSTANT.LABEL.READJUST}
            </div>
          </div>
        )}
    </>
  );
}

StateBadge.propTypes = {
  state: PropTypes.oneOf([
    CYBER_CONSTANT.STATES.NOT_ANSWERED,
    CYBER_CONSTANT.STATES.LEADING,
    CYBER_CONSTANT.STATES.MID_LEADING,
    CYBER_CONSTANT.STATES.MID_RANGE,
    CYBER_CONSTANT.STATES.MID_LAGGING,
    CYBER_CONSTANT.STATES.LAGGING,
  ]),
};

StateBadge.defaultProps = {
  state: CYBER_CONSTANT.STATES.NOT_ANSWERED,
};

export default StateBadge;
